import Receipt from "@mui/icons-material/Receipt";
import LocalShipping from "@mui/icons-material/LocalShipping";
import { ResourceProps } from "@refinedev/core";
import React from "react";

type NavigationItem = {
  name: string;
  list?: string;
  icon: React.ReactElement;
  children?: NavigationItem[];
};

const navigationItems: NavigationItem[] = [
  {
    name: "orders",
    list: "/orders",
    icon: <Receipt />,
  },
  {
    name: "shipmentPrices",
    list: "/shipment-prices",
    icon: <LocalShipping />,
  },
];

// Converts navigation items to ResourceProps list from Refine
export const getResources = () => {
  return navigationItems.reduce<ResourceProps[]>((acc, item) => {
    acc.push({
      name: item.name,
      list: item.list,
      meta: {
        icon: item.icon,
      },
    });

    if (item.children) {
      const childResources = item.children.map((child) => ({
        name: child.name,
        list: child.list,
        meta: {
          parent: item.name,
          icon: child.icon,
        },
      }));

      acc.push(...childResources);
    }

    return acc;
  }, []);
};
